import { Reveal } from "@/components/Reveal";

const capabilities = [
    {
        numeral: "I",
        name: "Commercial Edits",
        detail: "High-octane, rhythmically precise editorial cuts tailored for luxury brand campaigns and broadcast excellence.",
        testid: "capability-card-commercial-edits",
    },
    {
        numeral: "II",
        name: "Brand Storytelling",
        detail: "Narrative-driven cinematic films built around heritage, emotional resonance, and high-ticket positioning.",
        testid: "capability-card-brand-storytelling",
    },
    {
        numeral: "III",
        name: "Digital Asset Production",
        detail: "Master-grade color grading, VFX compositing, and multi-platform visual assets engineered for maximum conversion.",
        testid: "capability-card-digital-asset-production",
    },
];

const Capabilities = () => (
    <section
        id="capabilities"
        data-testid="capabilities-section"
        className="relative overflow-hidden px-6 py-32 sm:py-40 lg:px-16 lg:py-52"
    >
        <div className="mx-auto max-w-6xl">
            <Reveal className="text-center">
                <p className="mb-8 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    Atelier Offerings
                </p>
                <h2
                    data-testid="capabilities-title"
                    className="font-serif text-4xl font-normal tracking-[-0.01em] text-[#270057] sm:text-5xl lg:text-6xl"
                >
                    Capabilities
                </h2>
                <div className="royal-rule mx-auto mt-12 w-32" />
            </Reveal>

            <div className="mt-24 grid grid-cols-1 gap-8 md:grid-cols-3 lg:mt-32 lg:gap-10">
                {capabilities.map((c, i) => (
                    <Reveal key={c.numeral} delay={i * 0.15}>
                        <div
                            data-testid={c.testid}
                            className="group flex h-full flex-col items-center border border-[#270057]/20 bg-white px-10 py-16 text-center transition-[border-color,box-shadow,transform] duration-700 hover:-translate-y-2 hover:border-[#270057]/50 hover:shadow-[0_20px_70px_rgba(39,0,87,0.08)]"
                        >
                            <span className="text-royal-outline font-serif text-6xl font-normal transition-all duration-700 group-hover:[-webkit-text-stroke-color:rgba(39,0,87,0.8)]">
                                {c.numeral}
                            </span>
                            <h3 className="mt-10 font-serif text-2xl font-medium text-[#270057] lg:text-[1.7rem]">
                                {c.name}
                            </h3>
                            <div className="royal-rule mt-8 w-12 opacity-70 transition-all duration-700 group-hover:w-20 group-hover:opacity-100" />
                            <p className="mt-8 text-base font-normal leading-relaxed text-[#270057]">
                                {c.detail}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Capabilities;
